import { detectVideoEncoderConfig } from '@streamr/tv-engine/~/detectVideoEncoderConfig';
import { useEffect, useState } from 'react';
export function useHasSupportedVideoCodec() {
    const [supported, setSupported] = useState(undefined);
    useEffect(() => {
        let mounted = true;
        const checkVideoCodecSupport = async () => {
            const supported = !!(await detectVideoEncoderConfig());
            if (mounted) {
                setSupported(supported);
            }
        };
        // biome-ignore lint/nursery/noFloatingPromises: TODO
        checkVideoCodecSupport();
        return () => {
            mounted = false;
        };
    }, []);
    return supported;
}
